export interface GetReserveGroupReserveRequest {
  userId: string
  reserveGroupId: number
}

export function GetReserveGroupReserveRequestToJSON(
  value: GetReserveGroupReserveRequest
): any {
  return {
    user_id: value.userId !== '' ? value.userId : undefined,
    reserve_group_id:
      value.reserveGroupId !== 0 ? value.reserveGroupId : undefined
  }
}
